var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52461 17.5002H3.57461L15.5746 5.50024L15.0496 4.97524L14.5496 4.45024L2.52461 16.4752V17.5002ZM0.974609 19.0752V15.8502L15.6746 1.15024C15.9746 0.85024 16.3413 0.704407 16.7746 0.71274C17.2079 0.721074 17.5829 0.87524 17.8996 1.17524L18.8996 2.17524C19.2163 2.47524 19.3704 2.84191 19.3621 3.27524C19.3538 3.70857 19.1996 4.07524 18.8996 4.37524L4.19961 19.0752H0.974609ZM17.6996 3.25024L16.7496 2.30024L17.6996 3.25024ZM15.5746 5.50024L15.0496 4.97524L14.5496 4.45024L15.5746 5.50024Z",
    fill: "white",
    fillOpacity: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.0fd0f2e543063aea972027f5b25c1212.svg";
export { ForwardRef as ReactComponent };